import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { routes } from '../../../../routes';
import List from './List';
import Certification from './Certification';
import Pay from './Pay';

const mapStore = ({ user, creditTypes }) => ({
  renewal: user.renewal,
  certifications: user.userCertifications,
  certificationPayments: user.certificationPayments,
  creditTypes,
  extensions: user.extensions,
});

const Certifications = (props) => (
  <Switch>
    <Route exact path={routes.certificationsAndTraining.certifications.root} render={() => <List {...props} />} />
    <Route exact path={routes.certificationsAndTraining.certifications.pay} render={() => <Pay {...props} />} />
    <Route
      exact
      path={routes.certificationsAndTraining.certifications.view}
      render={() => <Certification {...props} />}
    />
  </Switch>
);

export default connect(mapStore)(Certifications);
